import React from 'react';
import DropdownSelect from '../../../../../components/dropdownSelect';
import { getRenderControl } from '../../../../../components/SingleControlCustom/getRenderControl';

const FilterDropdown = ({ config, isMultiple = false, isClear = true }) => {
  return (
    <DropdownSelect
      value={config.value}
      onChange={config.onChange}
      options={config.data}
      multiple={isMultiple}
      disabled={config.isLoading || config.disabled}
      loading={config.isLoading}
      renderControl={
        !isMultiple
          ? getRenderControl({
              options: config.data,
              isClear,
              onClearClick: () => {
                config.onChange(null);
              },
              value: config.value,
              placeholder: config.placeholder,
              disabled: config.isLoading || config.disabled,
              loading: config.isLoading,
            })
          : null
      }
    />
  );
};

export default FilterDropdown;
